export default {
  configuration: {
    title: 'Complétez les informations',
    footer: {
      help: 'Les choix suivants vont permettre d\'affiner notre préconisation financière'
    },
    monthlyPayment: {
      title: 'Vos versements',
      subtitle: 'Configurer vos versements à effectuer lors de cette opération',
      fieldTitle: 'Versements programmés mensuels',
      errorMax: "La capacité d'épargne disponible est de {amount}"
    },
    investmentHorizon: {
      title: "Horizon d'investissement",
      subtitle: "Définir un horizon d'investissement pour cette opération :",
      label: "Horizon d'investissement",
      placeholder: 'Sélectionner',
    }
  },
  contractSelection: {
    warningMessage: 'Attention: La composition de votre patrimoine financier ainsi que son niveau de risque, supérieur à votre profil investisseur, ne nous permettent pas de vous conseiller sur des investissements ce jour.',
    infoMessage: 'Pour votre information: Dans le cadre de notre évaluation visant à aligner vos investissements avec vos préférences d\'investisseur votre profil de risque, nous ne pouvons actuellement vous proposer d\'agir sur ce levier. Cette démarche est essentielle pour s\'assurer que les recommandations fournies correspondent non seulement à vos aspirations financières mais aussi à votre capacité à tolérer les fluctuations du marché.'
  }
}
